"use strict";

var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _validate = require("@widergy/web-utils/lib/validate");

var _fieldsHelper = require("../../utils/fieldsHelper");

var _FormField = _interopRequireDefault(require("../FormField"));

var FIELD_TYPES = _interopRequireWildcard(require("../../constants/fieldTypes"));

var _formTypes = require("../../types/formTypes");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var memoizedGetFieldValidation = _lodash.default.memoize(_fieldsHelper.getFieldValidation);

var memoizedGetFieldNormalizer = _lodash.default.memoize(_fieldsHelper.getFieldNormalizer);

var memoizedGenKeyMap = _lodash.default.memoize(_validate.genKeyMap);

var Form = /*#__PURE__*/function (_react$PureComponent) {
  _inherits(Form, _react$PureComponent);

  var _super = _createSuper(Form);

  function Form() {
    _classCallCheck(this, Form);

    return _super.apply(this, arguments);
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          formStructure = _this$props.formStructure,
          formVisibility = _this$props.formVisibility,
          showTitle = _this$props.showTitle,
          account = _this$props.account,
          components = _this$props.components,
          formClasses = _this$props.formClasses,
          fieldClasses = _this$props.fieldClasses,
          FieldComponent = _this$props.FieldComponent,
          replaceFieldNames = _this$props.replaceFieldNames,
          defaultMessages = _this$props.defaultMessages,
          FeedbackIcon = _this$props.FeedbackIcon,
          disableAllFields = _this$props.disableAllFields,
          fieldTypeProps = _this$props.fieldTypeProps,
          ignoreVisibility = _this$props.ignoreVisibility,
          useEditableKey = _this$props.useEditableKey;
      var LabelComponent = components[FIELD_TYPES.FIELD_LABEL];
      var fieldProps = (0, _fieldsHelper.generateFieldProps)(fieldTypeProps, formVisibility.selectedOptionsIds, account);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(_stylesModule.default.container, " ").concat(formClasses.formContainer)
      }, showTitle && formStructure.name && /*#__PURE__*/_react.default.createElement(LabelComponent, {
        xlarge: true,
        bold: true,
        className: "".concat(_stylesModule.default.formTitle, " ").concat(formClasses.formTitle)
      }, formStructure.name), (0, _fieldsHelper.groupFields)(formStructure.fields, formVisibility, ignoreVisibility).map(function (row) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: (0, _fieldsHelper.genRowKey)(row),
          className: "".concat(_stylesModule.default.fieldRow, " ").concat(formClasses.fieldRowContainer)
        }, row.map(function (field) {
          return /*#__PURE__*/_react.default.createElement(FieldComponent, {
            key: field.id,
            name: replaceFieldNames ? "id".concat(field.id) : field.key,
            field: _objectSpread({}, field, {
              read_only: field.read_only || disableAllFields || useEditableKey && field.editable === false
            }),
            component: _FormField.default,
            validate: memoizedGetFieldValidation(field, formVisibility.selectedOptionsIds, memoizedGenKeyMap(formStructure.fields, 'id'), defaultMessages, fieldProps[field.type]),
            normalize: memoizedGetFieldNormalizer(field),
            components: components,
            fieldClasses: fieldClasses,
            FeedbackIcon: FeedbackIcon,
            fieldProps: fieldProps
          });
        }));
      }));
    }
  }]);

  return Form;
}(_react.PureComponent);

Form.propTypes = _formTypes.FormTypes;
var _default = Form;
exports.default = _default;